import { DateTime } from 'luxon';

export const times = [
  '00:00',
  '00:10',
  '00:20',
  '00:30',
  '00:40',
  '00:50',
  '01:00',
  '01:10',
  '01:20',
  '01:30',
  '01:40',
  '01:50',
  '02:00',
  '02:10',
  '02:20',
  '02:30',
  '02:40',
  '02:50',
  '03:00',
  '03:10',
  '03:20',
  '03:30',
  '03:40',
  '03:50',
  '04:00',
  '04:10',
  '04:20',
  '04:30',
  '04:40',
  '04:50',
  '05:00',
  '05:10',
  '05:20',
  '05:30',
  '05:40',
  '05:50',
  '06:00',
  '06:10',
  '06:20',
  '06:30',
  '06:40',
  '06:50',
  '07:00',
  '07:10',
  '07:20',
  '07:30',
  '07:40',
  '07:50',
  '08:00',
  '08:10',
  '08:20',
  '08:30',
  '08:40',
  '08:50',
  '09:00',
  '09:10',
  '09:20',
  '09:30',
  '09:40',
  '09:50',
  '10:00',
  '10:10',
  '10:20',
  '10:30',
  '10:40',
  '10:50',
  '11:00',
  '11:10',
  '11:20',
  '11:30',
  '11:40',
  '11:50',
  '12:00',
  '12:10',
  '12:20',
  '12:30',
  '12:40',
  '12:50',
  '13:00',
  '13:10',
  '13:20',
  '13:30',
  '13:40',
  '13:50',
  '14:00',
  '14:10',
  '14:20',
  '14:30',
  '14:40',
  '14:50',
  '15:00',
  '15:10',
  '15:20',
  '15:30',
  '15:40',
  '15:50',
  '16:00',
  '16:10',
  '16:20',
  '16:30',
  '16:40',
  '16:50',
  '17:00',
  '17:10',
  '17:20',
  '17:30',
  '17:40',
  '17:50',
  '18:00',
  '18:10',
  '18:20',
  '18:30',
  '18:40',
  '18:50',
  '19:00',
  '19:10',
  '19:20',
  '19:30',
  '19:40',
  '19:50',
  '20:00',
  '20:10',
  '20:20',
  '20:30',
  '20:40',
  '20:50',
  '21:00',
  '21:10',
  '21:20',
  '21:30',
  '21:40',
  '21:50',
  '22:00',
  '22:10',
  '22:20',
  '22:30',
  '22:40',
  '22:50',
  '23:00',
  '23:10',
  '23:20',
  '23:30',
  '23:40',
  '23:50',
];

export function convert24HourTo12Hour(time: string | undefined) {
  if (!time) return '';
  // Split the time into hours and minutes
  let [hours, minutes] = time.split(':') as [string | number, string | number];

  // Convert hours to a number
  hours = parseInt(hours as string, 10);

  // Determine AM or PM suffix
  const suffix = hours >= 12 ? 'PM' : 'AM';

  // Convert hours from 24-hour to 12-hour format
  hours = hours % 12 || 12; // Convert '0' or '12' to '12'

  // Format hours and minutes as two-digit strings
  hours = hours.toString().padStart(2, '0');
  minutes = minutes.toString().padStart(2, '0');

  // Return the formatted time
  return `${hours}:${minutes} ${suffix}`;
}

export const formatDate = (iso: string, timezone?: string) => {
  const date_str = iso;
  const options = {
    timezone,
    year: 'numeric' as const,
    month: 'long' as const,
    day: 'numeric' as const,
  };
  const formatted = new Date(date_str).toLocaleDateString('en-US', options);

  return formatted;
};

export const formatDateTime = (iso: string) => {
  const date_str = iso,
    options = {
      year: 'numeric' as const,
      month: 'long' as const,
      day: 'numeric' as const,
      time: 'long' as const,
    },
    formatted = new Date(date_str).toLocaleTimeString('en-US', options);

  return formatted;
};

export function ampmTo24h(time12h: string): string {
  const [time, modifier] = time12h.trim().split(' ');
  const [hours, minutes] = time.split(':');

  let hoursNum = parseInt(hours, 10);

  if (modifier.toUpperCase() === 'AM' && hoursNum === 12) {
    hoursNum = 0;
  } else if (modifier.toUpperCase() === 'PM' && hoursNum !== 12) {
    hoursNum += 12;
  }

  return `${hoursNum.toString().padStart(2, '0')}:${minutes}`;
}

export const dateTimeInitial = DateTime.now()
  .set({ hour: 0, minute: 0, second: 0 })
  .toJSDate();

export const formatDateToTime24h = (date: Date) => {
  return ampmTo24h(DateTime.fromJSDate(date).toFormat('hh:mm a'));
};

export const format24hToDate = (time24h: string) => {
  return DateTime.fromFormat(time24h, 'HH:mm').toJSDate();
};

export const formatMinutesToHoursMinutes = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return `${hours} hr`;
  }

  return `${hours} hr ${remainingMinutes} min`;
};
